import { useEffect } from "react";
import { Slot } from "expo-router";
import Hotjar from "@hotjar/browser";

import { MainLayout } from "~/components/layout/layout";
import { OnlyAuthorized } from "~/components/only-authorized";
import { useSession } from "~/hooks";

export default function Layout() {
  const { user } = useSession();

  useEffect(() => {
    if (Hotjar.isReady()) {
      Hotjar.identify(user?.id ?? "", {
        name: user?.name ?? "",
        email: user?.email ?? "",
      });
    }
  }, [user]);

  return (
    <OnlyAuthorized>
      <MainLayout>
        <Slot />
      </MainLayout>
    </OnlyAuthorized>
  );
}
